import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { prettifyDates } from '../../../helpers/prettifiers'
import { prettifyPrice } from '../../../helpers/prettifyFunctions'
import i18n from '../../../localization/i18next'
import query from 'query-string'

const Summary = styled.div`
    padding: 2rem;
    box-shadow: ${p => p.theme.out};
    background: ${p => p.theme.low};
    border-radius: var(--smallRadius);
`

const SummaryItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const SummarySep = styled.div`
    margin: 1rem 0;
    height: 2px;
    width: 100%;
    background: ${p => p.theme.mid};
`

const SummaryText = styled.div`
    padding: 1rem;
    //border-radius: var(--smallRadius);
    //border: 1px dashed var(--grey);
    background: ${p => p.theme.mid};
    margin: 2rem 0;
    border-radius: 0.2rem;
    border-left: 4px solid var(--focus);
   // border: 2px dashed var(--greyDark);
        transition-property: background, border;
        transition-duration: .5s;
      //  border-radius: var(--smallRadius);
`

const SummaryPrice = styled.div`
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    justify-content: space-between;
`

export default function Summary_(props) {

    const queryParams = query.parse(window?.location?.search);

    const {t} = useTranslation();
    const lang = i18n.language ? i18n.language : "el";


    const paid_at_date = () => {
        let date = props?.trial ? Date.now() + parseInt((props?.discount?.couponInfo?.trialDays) * 24 * 60 * 60 * 1000) : Date.now();
        return prettifyDates(date, false, lang); // Pass false to indicate it's not a Unix timestamp
    }
    

     function prettifyCurrency(currency) {
        if (currency == "eur") return "€";
        else return currency;
    }

  return (
    <Summary>
        <SummaryItem>
            <h3>{t("Price breakdown")}</h3>
            {/* {props?.trial ? <h2>{prettifyCurrency('eur')} 0,00</h2> : null} */}
        </SummaryItem>
        <SummarySep></SummarySep>
       <SummaryPrice>
            <p>{t("Boost amount")}</p>
            <h5>{prettifyCurrency(props?.currency)} {prettifyPrice(props?.wholeAmount * 0.87 * 100)}</h5>
        </SummaryPrice>
        <SummaryPrice>
            <p>{t("Fee")}</p>
            {queryParams?.mode == 'own-ad-account' ?
            <h5>{prettifyCurrency(props?.currency)} {prettifyPrice(props?.amount)}</h5>
            :
            <h5>{prettifyCurrency(props?.currency)} {prettifyPrice(props?.amount * 0.13)}</h5>
            }
        </SummaryPrice>
        <SummaryPrice>
            <p>{t("Tax")}</p>
            <h5>{prettifyCurrency(props?.currency)} {prettifyPrice(props?.tax)}</h5>
        </SummaryPrice>
        <SummarySep></SummarySep>
        <SummaryItem>
            <div>
                <h4>{t("Payable at")}:</h4>
                <h6>{paid_at_date()}</h6>
            </div>
            <h2>{prettifyCurrency(props?.currency)} {prettifyPrice(props?.total)}</h2>
        </SummaryItem>
        <SummaryText>
            <h5>{t("Disclaimer")}</h5>
            <p>{(t("This is an one-time payment. The amount of"))} {' '}
                <b>€{Math.round(props?.wholeAmount * 0.87 * 100) / 100}</b> {' '}
                {t("will be used on the existing Quest, at the dates")} {' '}
                <b>{props?.startDate} - {props?.endDate}.</b> {' '}
                {t("To avoid any disruption of service, please ensure")} {' '}
                { queryParams?.mode == 'own-ad-account' ?  (t("that you will have no outstanding debts to Meta and"))  : ''} {' '}
                 {t("that you will have settled any outstanding issues with your Doitforme subscription at the time of the boost")}.</p>
        </SummaryText>
    </Summary>
  )
}
